import React from "react";
import { AutopayBadge, EbillsBadge } from "compid/ui/UIBadge";

/**
 * @function BillerBadgeView
 * @return {React.Component}
 * @param {Boolean} hasAutopay - Indicates if the biller has autopay enabled.
 * @param {Boolean} hasEbills - Indicates if the biller has e-bills enabled.
 * @exported true
 * @description This is a component shown throughout the biller view that shows if the biller has autopay or e-bills enabled.
 */
export default function BillerBadgeView(props) {
    const { hasAutopay = false, hasEbills = false } = props;

    return (
        <div className="biller-badge-view flex-container flex-horizontal align-center">
            {hasAutopay && <AutopayBadge />}
            {hasEbills && <EbillsBadge />}
        </div>
    )
}
